module.exports = __webpack_public_path__ + "assets/aa6e005c3e3f1064ebe85a950b5b8a11.mp3";